// Coupon codes
export const NEW_ON_BOUNCE_DISCOUNT_CODE = "NEWONBOUNCE"
export const BUY_4_GET_1_DISCOUNT_CODE = "BUY4GET1"
export const AUTO_APPLIED_COUPONS = [NEW_ON_BOUNCE_DISCOUNT_CODE, BUY_4_GET_1_DISCOUNT_CODE]
// Persistency
export const PERSISTED_THIRTY_DAYS_MS = 30 * 86400 * 1000
